<template>
  <div class="left cadfm-flexitem-fixed" v-if="partId">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="toggleLeftPanel" icon="hide" bold text="Hide" tooltip="Hide panel" :disabled="false" />



        </b-navbar-nav>
      </action-bar>
      <action-content>
        <div class="Tabs">
          <b-tabs card>

            <b-tab :title="lang.Content.tab_Revisions" :title-link-class="textColors" :title-item-class="textColors"
              active>
              <!-- <p>{{lang.Content.infotext_1}}: {{selectedProjectName}}<br>
              {{ lang.Content.infotext_2 }}: {{ projectCategory }}</p> -->
              <!-- <RevisionTableComponent :lang="lang.Content.RevisionsTable"></RevisionTableComponent> -->
              <InfoElementComponent :lang="lang.Content.InfoElement"></InfoElementComponent>
              <ProjectRevisionHistoryComponent :lang="lang.Content.RevisionsTable"></ProjectRevisionHistoryComponent>
            </b-tab>
            <!-- <b-tab :title="lang.Content.tab_Diagram"  :title-link-class="textColors" :title-item-class="textColors" >
              <p>{{info}}</p> -->
            <!--<RevisionDiagramComponent :lang="lang.Content.RevisionsDiagram"></RevisionDiagramComponent>-->
            <!-- </b-tab> -->

          </b-tabs>

        </div>
      </action-content>
    </action-panel>

  </div>
</template>


<script>

//import Right from '@/components/PartManager/Right/Right'
import { mapGetters } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
// import RevisionTableComponent from '@/components/shared/RevisionTableComponent'
import ProjectRevisionHistoryComponent from '@/components/shared/ProjectRevisionHistoryComponent'
import InfoElementComponent  from '@/components/shared/InfoElementComponent'

export default {
  name: 'Left',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,

    // RevisionTableComponent,
    ProjectRevisionHistoryComponent,
    InfoElementComponent
    //RevisionDiagramComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      name: "LeftContentProjectDetails",
      partId: true,
      
    }
  },
  computed: {
    
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    
  },

  created() {

    

  },
  watch: {
    
  },
  updated() {
        

  },
  methods: {
    
    toggleLeftPanel(){

      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;

    }
  }
}
</script>


<style scoped>
.left{
  border-right: 1px solid #666;
  min-width: 400px;
}

.center-content{
  text-align: center;
}
img {
  max-width:200px;
  max-height:200px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectDetails/Left/Left.vue